import GuestStories from "../components/GuestStories";
import LocationSection from "../components/LocationSection";
import OverallRating from "../components/OverallRating";
import ReviewsHero from "../components/ReviewsHero";
import ContactSection from "../components/ContactSection";
import Navbar from "../components/Navbar";
import BookingFooter from "../components/BookingFooter";

export default function Contact() {

    return(
        <>
            <Navbar />
            <ReviewsHero />
            <ContactSection />
            <OverallRating />
            <GuestStories />
            <LocationSection />
            <BookingFooter />
        </>
    )
}